import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { PROVIDER_CHAT_UNAVAILABLE_MESSAGE } from "@api/shared-runtime/provider-chat-availability";
import { Loader2, MessageSquare } from "lucide-react";

export function OrganizationProviderChatButton({
  canChat,
  onClick,
  isLoading = false,
  className,
  iconClassName = "h-4 w-4",
}: {
  canChat: boolean;
  onClick: () => void;
  isLoading?: boolean;
  className?: string;
  iconClassName?: string;
}) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex">
            <Button
              type="button"
              variant="outline"
              size="sm"
              className={cn("min-h-11 gap-2 text-primary", className)}
              disabled={!canChat || isLoading}
              onClick={onClick}
              aria-label={
                canChat
                  ? "Chat with provider"
                  : PROVIDER_CHAT_UNAVAILABLE_MESSAGE
              }
            >
              {isLoading ? (
                <Loader2 className={cn(iconClassName, "animate-spin")} />
              ) : (
                <MessageSquare className={iconClassName} />
              )}
              <span>Chat</span>
            </Button>
          </span>
        </TooltipTrigger>
        {!canChat && (
          <TooltipContent className="max-w-72">
            {PROVIDER_CHAT_UNAVAILABLE_MESSAGE}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
